<script>
import { FormWizard, TabContent } from "vue-form-wizard";

import instructions from "@/components/step-apartment-complex/martyr/instructions";
import specifications from "@/components/step-apartment-complex/martyr/specifications";
import martyr_info from "@/components/step-apartment-complex/martyr/martyr-info";
import beneficial_info from "@/components/step-apartment-complex/martyr/beneficial-info";
import applicant_info from "@/components/step-apartment-complex/martyr/applicant-info";
import family_info from "@/components/step-apartment-complex/martyr/family-info";

import Martyr from "../../../model/martyr";
import MartyrServices from "../../../services/martyr";
import { swal } from "../../../helpers/handle_error.js";
import AlertError from "@/components/alert_error";
import VueQRCodeComponent from "vue-qrcode-component";
import html2canvas from "html2canvas";
import unitTestMartyr from "../../../helpers/unit_test_martyr";

import { mapGetters } from "vuex";

export default {
  components: {
    FormWizard,
    TabContent,
    instructions,
    specifications,
    martyr_info,
    beneficial_info,
    applicant_info,
    family_info,
    AlertError,
    "qr-code": VueQRCodeComponent,
  },
  data() {
    return {
      //Page errors.
      errors: [],

      isPrintedInformation: false,
      fullName: "",
      Id: "",
      date: "",
      qrCodeContent: "",
      showAlert: false,

      //sacrificer code.
      code: this.$route.params.code,
      sacrificer: null,
    };
  },
  computed: {
    ...mapGetters("authSacrificer", ["getSacrificer"]),
  },
  methods: {
    handleError(error) {
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    resetForm() {
      this.errors = [];
      swal.close();
    },
    onComplete: function () {
      swal.loading();

      var data = new Martyr(
        this.code,
        this.$refs["instructions"],
        this.$refs["specifications"],
        this.$refs["martyr_info"],
        this.$refs["beneficial_info"],
        this.$refs["applicant_info"],
        this.$refs["family_info"]
      );

      MartyrServices.addMartyr(data.toFormData())
        .then((response) => {
          let data = response.data.data;

          this.fullName = data.fullName;
          this.Id = data.id;
          this.date = data.date;

          this.qrCodeContent = JSON.stringify({
            Id: this.Id,
            fullName: this.fullName,
            date: this.date,
          });

          this.isPrintedInformation = true;
          this.resetForm();
        })
        .catch((error) => {
          this.handleError(error);
          swal.close();
        });
    },
    validateStep(name) {
      var refToValidate = this.$refs[name];
      return refToValidate.validate();
    },
    mergePartialModels(model, isValid) {
      if (isValid) {
        // merging each step model into the final model
        this.finalModel = Object.assign({}, this.finalModel, model);
      }
    },
    // print card
    async printThis() {
      const el = this.$refs.printcontent;
      const options = { type: "dataURL" };
      const printCanvas = await html2canvas(el, options);
      const link = document.createElement("a");
      link.setAttribute("download", this.Id + ".jpg");
      link.setAttribute(
        "href",
        printCanvas.toDataURL("image/jpg").replace("image/jpg", "image/octet-stream")
      );
      link.click();
    },
  },
  mounted() {
    if (process.env.NODE_ENV == "development") {
      unitTestMartyr(this.$refs);
    }

    this.sacrificer = this.getSacrificer;
  },
};
</script>

<template>
  <div>
    <img class="img-wallpaper" src="@/assets/images/wallpaper4.png" alt="" />
    <!-- Features start -->
    <section
      class="section"
      id="features"
      style="min-height: calc(100vh - 163px); padding-top: 40px"
    >
      <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center mb-5">
              <a href="https://emtenan.org/"><h4>منصة إمتنان</h4></a>
              <h5>
                <div class="small-title">استمارة قروض الاسكان ( الخاصة بالشهداء )</div>
              </h5>
            </div>
          </div>
          <div v-if="isPrintedInformation" class="text-center print-cover">
            <div class="card-print con-print text-center" ref="printcontent">
              <h5>استمارة قروض الاسكان ( الخاصة بالشهداء )</h5>
              <p><strong>الاسم :</strong> {{ fullName }}</p>
              <p><strong>تاريخ التقديم :</strong> {{ date }}</p>
              <p><strong>رقم الاستمارة :</strong> {{ Id }}</p>
              <qr-code class="qr-code" :text="qrCodeContent"></qr-code>
              <hr />
              <div class="">
                <p class="mb-1">هيأة الحشد الشعبي</p>
                <p class="mb-0">المديرية العامة للعلاقات والخدمات الاجتماعية</p>
              </div>
            </div>
            <button
              type="button"
              id="btn3"
              @click="printThis"
              class="btn bg-color-blue font-color-white btn-sm mt-2"
            >
              حفظ وصل التسجيل
            </button>
          </div>
          <div v-else class="col-lg-12">
            <div class="mb-5">
              <form-wizard
                color="#556ee6"
                error-color="#a94442"
                step-size="xs"
                back-button-text="السابق"
                next-button-text="التالي"
                finish-button-text="ارسال البيانات"
                @on-complete="onComplete"
              >
                <tab-content
                  title="تعليمات التقديم"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('instructions')"
                >
                  <instructions
                    ref="instructions"
                    @on-validate="mergePartialModels"
                  ></instructions>
                </tab-content>
                <tab-content
                  title="مواصفات الوحدة السكنية"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('specifications')"
                >
                  <specifications
                    ref="specifications"
                    @on-validate="mergePartialModels"
                  ></specifications>
                </tab-content>
                <tab-content
                  title="معلومات الشهيد"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('martyr_info')"
                >
                  <martyr_info
                    ref="martyr_info"
                    @on-validate="mergePartialModels"
                    :sacrificer="sacrificer"
                  ></martyr_info>
                </tab-content>
                <tab-content
                  title="معلومات المستفيدين"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('beneficial_info')"
                >
                  <beneficial_info
                    ref="beneficial_info"
                    @on-validate="mergePartialModels"
                  ></beneficial_info>
                </tab-content>
                <tab-content
                  title="معلومات مقدم الطلب"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('applicant_info')"
                >
                  <applicant_info
                    ref="applicant_info"
                    @on-validate="mergePartialModels"
                    :sacrificer="sacrificer"
                  ></applicant_info>
                </tab-content>
                <tab-content
                  title="معلومات عائلة مقدم الطلب"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('family_info')"
                >
                  <family_info
                    ref="family_info"
                    @on-validate="mergePartialModels"
                  ></family_info>
                </tab-content>
                <tab-content
                  title="ارسال البيانات"
                  icon="mdi mdi-checkbox-marked-circle-outline"
                >
                  <h4 class="my-5 text-center">
                    اضغط على ( ارسال البيانات ) لارسال الاستمارة .
                  </h4>
                </tab-content>
              </form-wizard>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </section>
    <!-- Features end -->

    <!-- Footer start -->
    <footer class="landing-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <img src="@/assets/images/logo.png" alt height="25" />
            <span class="mx-2">منصة امتنان</span>
          </div>
          <div class="col-md-6">
            <p class="mt-1 text-md-end d-sm-block mb-0">
              {{ new Date().getFullYear() }} © جميع الحقوق محفوظة
            </p>
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer end -->
  </div>
</template>
